<section class="listing-summary" [class.luxury]="listing.isLuxury" [class.commercial]="listing.isCommercial">
  <div #topsubbar id="topsubbar" class="is-flex sub-top">
    <app-back-button class="back-to" [showLabel]="false" [img]="backButton"></app-back-button>
    <button *ngIf="!listing.isOffMarket" class="btn schedule-viewing" [class.btn-polar-gradient]="!listing.isLuxury" [class.btn-primary]="!listing.isLuxury" [class.btn-luxury]="listing.isLuxury" (click)="showScheduleViewingClicked.emit($event)">
      <span [translate]="'contact.schedule-a-viewing'"></span>
    </button>
    <button *ngIf="!listing.isOffMarket" class="btn contact-agent" [class.btn-polar-gradient]="!listing.isLuxury" [class.btn-primary]="!listing.isLuxury" [class.btn-luxury]="listing.isLuxury" (click)="showContactAgentClicked.emit($event)">
      <span [translate]="listing.isLuxury? 'contact.request-more-details':'contact.request-more-info'"></span>
    </button>
  </div>
  <section class="details-summary" [class.details-summary--offmarket] = "listing.isOffMarket">
    <div class="address is-flex has-flex-align-center">
      <div *ngIf="hasNextListings && !listing.isOffMarket" class="controls" (click)="previousListingClicked.emit($event)">
        <i *ngIf="listing.isLuxury" class="material-icons">chevron_left</i>
        <img *ngIf="!listing.isLuxury" class="control left" height="26" width="11" alt="Previous Listing"
             src="{{'/assets/icons/general_navigation/Chevron_left@1x.svg' | staticp}}"/>
      </div>
      <div class="flex-one text-center" [class.has-margin]="!hasCopiedText">
        <ng-container *ngIf="!hasCopiedText">
          <div *ngIf="listing.isOffMarket" class="details-off-market__not-for-sale"> <div class="details-off-market__not-for-sale-icon">!</div>{{ 'listing-summary.not-for-sale' | translate }}</div>
          <h1 class="full-address listing-details__address clipboard-text" [class.copied]="hasCopiedText"
          [attr.data-clipboard-text]="listing.address + ' ' + listing.city">{{ listing.address | titlecase  }}</h1>
          <h5>
            <app-listing-address class="clipboard-text" [class.copied]="hasCopiedText"
            [attr.data-clipboard-text]="listing.address + ' ' + listing.city"
              [parts]="[listing.communityName, listing.city.charAt(0).toUpperCase() + listing.city.slice(1).toLowerCase(), listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
          </h5>
          <div class="details-off-market__image" *ngIf="listing.isOffMarket">
              <div class="details-off-market__image-overlay">
                {{ 'listing-summary.not-for-sale' | translate }}
              </div>
            </div>
            <div *ngIf="listing.isOffMarket" class="details-off-market">
              <div class="details-off-market__container">
                <div class="details-off-market__estimated-value-container"><div class="details-off-market__estimated-value-title">{{ 'listing-summary.estimated-value' | translate }}</div>
                <app-estimated-value [listing]="listing"></app-estimated-value>
              </div>
              <a *ngIf="listing.province === BritishColumbiaStateShort" 
                (click)="homeEstimateLinkClick.emit($event)"
                class="details-off-market__find-estimated-value">
                  {{ 'listing-summary.find-value-of-another' | translate }} <i _ngcontent-c4="" class="material-icons">chevron_right</i>
              </a>
              </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasCopiedText">
          <div class="copied-text-view" translate="details.copied"></div>
        </ng-container>
      </div>
      <div *ngIf="hasNextListings  && !listing.isOffMarket" class="controls" (click)="nextListingClicked.emit($event)">
        <i *ngIf="listing.isLuxury" class="material-icons">chevron_right</i>
        <img *ngIf="!listing.isLuxury" class="control right" height="26" width="11" alt="Next Listing"
             src="{{'/assets/icons/general_navigation/Chevron_right@1x.svg' | staticp}}"/>
      </div>
    </div>
    <app-listing-card *ngIf="!listing.isOffMarket" [listing]="listing" [isListingDetails]="true" [isSelectedCard]="true" [includeAddress]="false"
                      [showMap]="showMap" [currentSlideIndex]="currentSlideIndex"
                      (click)="toggleExpandedGalleryView.emit(true)" (changeCarouselIndex)="currentSlideIndex = $event">
      <p class="mortgage-payment-quick text-center"
         *ngIf="!listing.isLeaseOrRental && !listing.isCommercial && mortgagePaymentAmount"
         translate="details.mortgage-payment"
         [translateParams]="{frequency: 'Monthly', price: mortgagePaymentAmount}"></p>
    </app-listing-card>
  </section>
  <app-modal *ngIf="!listing.isOffMarket" [shouldShowModal]="showExpandedGalleryView" (closeModal)="toggleExpandedGalleryView.emit(false)"
             [templateRef]="expandedGalleryRef">
  </app-modal>
  <ng-template #expandedGalleryRef>
    <header class="is-flex has-flex-align-center" style="margin-bottom: 20px;">
      <img *ngIf="!listing.isCommercial && !listing.isLuxury" src="{{'/assets/BalloonLarge.svg' | staticp}}"
           alt="RE/MAX Logo" height="73" width="56"/>
      <div class="flex-one is-flex-column">
        <div class="street-address">{{listing.address}}</div>
        <app-listing-address
          [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
      </div>
    </header>
    <app-rm-carousel [images]="listing.imageUrls" [showHighDprImages]="true"
                     (onChangeCarouselIndex)="currentSlideIndex = $event" [isCommercial]="listing.isCommercial"
                     [currentSlideIndex]="currentSlideIndex" carouselParentName="expanded-view"
                     [imageQualityPercentage]="100"></app-rm-carousel>
    <a style="margin: 20px 0;" class="btn btn-primary btn-full-sized" translate="contact.request-more-info"
       (click)="showContactAgentClicked.emit($event)"></a>
    <div class="favourites text-center" style="margin-right: 10px;" (click)="toggleFavourite($event)">
      <a style="margin-right: 10px;">{{ (listing.isFavourite ? 'listing-summary.remove-from-saved-listings' :
        'listing-summary.add-to-saved-listings') | translate}}</a>
      <img
        [src]="listing.isFavourite ? ('/assets/icons/heart/heart_icon_red.png' | staticp ) : ('/assets/icons/heart/heart_icon.png' | staticp )"
        height="17" width="18" alt="Favourite"/>
    </div>
  </ng-template>
</section>
